import { Component, inject, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-confirm-dialog',
  templateUrl: 'confirm-dialog.component.html'
})
export class ConfirmDialogComponent {

  private readonly translateService = inject(TranslateService);
  readonly activeModal = inject(NgbActiveModal);

  // 'default' or 'danger'
  @Input() type = 'default';
  @Input() title = this.translateService.instant('Modal.Confirm.Title');
  @Input() message = this.translateService.instant('Modal.Confirm.Message');
  @Input() yesText = this.translateService.instant('Button.Yes');
  @Input() noText = this.translateService.instant('Button.No');

  constructor() {
    if(this.type=='danger'){
      this.noText = this.translateService.instant('Button.Cancel');
    }
  }
}
